module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDkgMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMyA3LjRMNC45IDEwVi42SDMuNlYxMEwxLjIgNy40bC0xIDEgNCA0LjIgNC00LjJ6IiBmaWxsPSIjQTVEMkUyIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/img/mini-arrow.svg
// module id = 78
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512